import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';

export const UPDATE_ISSUE_FIELDS_EXPERIENCE: ExperienceDetails = {
	experience: 'updateIssueFields',
	packageName: 'jiraWorkManagementBoard',
	teamName: 'wanjel',
};

export class UpdateFieldsValidationError extends Error {}
